import antforAvalonTemplate from '../../../../utils/PMS_templates/Avalon2_template.xlsx';
import antforCivitfunTemplate from '../../../../utils/PMS_templates/Avalon_template.xlsx';
import aviratoTemplate from '../../../../utils/PMS_templates/Avirato_template.xlsx';
import bookiproTemplate from '../../../../utils/PMS_templates/Bookipro_template.xlsx';
import cataloniaTemplate from '../../../../utils/PMS_templates/Catalonia_template.xlsx';
import elektrawebTemplate from '../../../../utils/PMS_templates/Elektraweb_template.xlsx';
import ericsoftTemplate from '../../../../utils/PMS_templates/Ericsoft_template.xlsx';
import guestlineTemplate from '../../../../utils/PMS_templates/Guestline_template.xlsx';
import guestProTemplate from '../../../../utils/PMS_templates/GuestPro_template.xlsx';
import hestiaTemplate from '../../../../utils/PMS_templates/Hestia_template.xlsx';
import hostTemplate from '../../../../utils/PMS_templates/Host_template.xlsx';
import hoteligaTemplate from '../../../../utils/PMS_templates/Hoteliga_template.xlsx';
import mewsTemplate from '../../../../utils/PMS_templates/Mews_template.xlsx';
import minihotelTemplate from '../../../../utils/PMS_templates/Minihotel_template.xlsx';
import norayTemplate from '../../../../utils/PMS_templates/Noray_template.xlsx';
import norayHTLTemplate from '../../../../utils/PMS_templates/Noray_htl_template.xlsx';
import octorateTemplate from '../../../../utils/PMS_templates/Octorate_template.xlsx';
import ohipTemplate from '../../../../utils/PMS_templates/Ohip_template.xlsx';
import ohtelsTemplate from '../../../../utils/PMS_templates/Ohtels_template.xlsx';
import operaTemplate from '../../../../utils/PMS_templates/Opera_template.xlsx';
import othelloTemplate from '../../../../utils/PMS_templates/Othello_template.xlsx';
import passepartoutTemplate from '../../../../utils/PMS_templates/Passepartout_template.xlsx';
import porthotelsTemplate from '../../../../utils/PMS_templates/Porthotels_template.xlsx';
import protelTemplate from '../../../../utils/PMS_templates/Protel_template.xlsx';
import quohotelTemplate from '../../../../utils/PMS_templates/Quohotel_template.xlsx';
import rmsTemplate from '../../../../utils/PMS_templates/Rms_template.xlsx';
import roomCloudTemplate from '../../../../utils/PMS_templates/RoomCloud_template.xlsx';
import selentaGroupTemplate from '../../../../utils/PMS_templates/SelentaGroup_template.xlsx';
import sihotTemplate from '../../../../utils/PMS_templates/Sihot_template.xlsx';
import sihot360template from '../../../../utils/PMS_templates/Sihot360_template.xlsx';
import standard2Template from '../../../../utils/PMS_templates/Standard2_template.xlsx';
import standard3Template from '../../../../utils/PMS_templates/Standard3_template.xlsx';
import stelleTemplate from '../../../../utils/PMS_templates/Stelle_template.xlsx';
import suitechTemplate from '../../../../utils/PMS_templates/Suitech_template.xlsx';
import tecsoftTemplate from '../../../../utils/PMS_templates/Tecsoft_template.xlsx';
import timonHotelTempalte from '../../../../utils/PMS_templates/TimonHotel_template.xlsx';
import tmsTemplate from '../../../../utils/PMS_templates/Tms_template.xlsx';
import totvsTemplate from '../../../../utils/PMS_templates/Totvs_template.xlsx';
import ulysesCloudTemplate from '../../../../utils/PMS_templates/UlysesCloud_template.xlsx';
import verialTemplate from '../../../../utils/PMS_templates/Verial_template.xlsx';
import winhotelTemplate from '../../../../utils/PMS_templates/Winhotel_template.xlsx';

//Default search PMS Template
const PMS_TEMPLATES_ID = {
  6: { template: antforAvalonTemplate, nameTemplate: 'Avalon2_template.xlsx' },
  7: { template: antforCivitfunTemplate, nameTemplate: 'Avalon_template.xlsx' },
  43: { template: aviratoTemplate, nameTemplate: 'Avirato_template.xlsx' },
  33: { template: bookiproTemplate, nameTemplate: 'Bookipro_template.xlsx' },
  23: { template: cataloniaTemplate, nameTemplate: 'Catalonia_template.xlsx' },
  39: { template: elektrawebTemplate, nameTemplate: 'Elektraweb_template.xlsx' },
  42: { template: ericsoftTemplate, nameTemplate: 'Ericsoft_template.xlsx' },
  27: { template: guestlineTemplate, nameTemplate: 'Guestline_template.xlsx' },
  38: { template: guestProTemplate, nameTemplate: 'GuestPro_template.xlsx' },
  45: { template: hestiaTemplate, nameTemplate: 'Hestia_template.xlsx' },
  40: { template: hostTemplate, nameTemplate: 'Host_template.xlsx' },
  34: { template: hoteligaTemplate, nameTemplate: 'Hoteliga_template.xlsx' },
  11: { template: mewsTemplate, nameTemplate: 'Mews_template.xlsx' },
  36: { template: minihotelTemplate, nameTemplate: 'Minihotel_template.xlsx' },
  13: { template: norayTemplate, nameTemplate: 'Noray_template.xlsx' },
  65: { template: norayHTLTemplate, nameTemplate: 'Noray_htl_template.xlsx' },
  37: { template: octorateTemplate, nameTemplate: 'Octorate_template.xlsx' },
  30: { template: ohipTemplate, nameTemplate: 'Ohip_template.xlsx' },
  55: { template: ohtelsTemplate, nameTemplate: 'Ohtels_template.xlsx' },
  14: { template: operaTemplate, nameTemplate: 'Opera_template.xlsx' },
  56: { template: othelloTemplate, nameTemplate: 'Othello_template.xlsx' },
  60: { template: passepartoutTemplate, nameTemplate: 'Passepartout_template.xlsx' },
  20: { template: porthotelsTemplate, nameTemplate: 'Porthotels_template.xlsx' },
  21: { template: protelTemplate, nameTemplate: 'Protel_template.xlsx' },
  10: { template: quohotelTemplate, nameTemplate: 'Quohotel_template.xlsx' },
  31: { template: rmsTemplate, nameTemplate: 'Rms_template.xlsx' },
  24: { template: roomCloudTemplate, nameTemplate: 'RoomCloud_template.xlsx' },
  63: { template: selentaGroupTemplate, nameTemplate: 'SelentaGroup_template.xlsx' },
  15: { template: sihotTemplate, nameTemplate: 'Sihot_template.xlsx' },
  54: { template: sihot360template, nameTemplate: 'Sihot360_template.xlsx' },
  5: { template: standard2Template, nameTemplate: 'Standard2_template.xlsx' },
  25: { template: standard3Template, nameTemplate: 'Standard3_template.xlsx' },
  28: { template: stelleTemplate, nameTemplate: 'Stelle_template.xlsx' },
  68: { template: suitechTemplate, nameTemplate: 'Suitech_template.xlsx' },
  16: { template: tecsoftTemplate, nameTemplate: 'Tecsoft_template.xlsx' },
  17: { template: timonHotelTempalte, nameTemplate: 'TimonHotel_template.xlsx' },
  35: { template: tmsTemplate, nameTemplate: 'Tms_template.xlsx' },
  29: { template: totvsTemplate, nameTemplate: 'Totvs_template.xlsx' },
  18: { template: ulysesCloudTemplate, nameTemplate: 'UlysesCloud_template.xlsx' },
  41: { template: verialTemplate, nameTemplate: 'Verial_template.xlsx' },
  19: { template: winhotelTemplate, nameTemplate: 'Winhotel_template.xlsx' },
};

//Alternative search PMS template (case id is null)
const PMS_TEMPLATES_NAME = {
  Avalon2: { template: antforAvalonTemplate, nameTemplate: 'Avalon2_template.xlsx' },
  Avalon: { template: antforCivitfunTemplate, nameTemplate: 'Avalon_template.xlsx' },
  Avirato: { template: aviratoTemplate, nameTemplate: 'Avirato_template.xlsx' },
  Bookipro: { template: bookiproTemplate, nameTemplate: 'Bookipro_template.xlsx' },
  Catalonia: { template: cataloniaTemplate, nameTemplate: 'Catalonia_template.xlsx' },
  Elektraweb: { template: elektrawebTemplate, nameTemplate: 'Elektraweb_template.xlsx' },
  Ericsoft: { template: ericsoftTemplate, nameTemplate: 'Ericsoft_template.xlsx' },
  Guestline: { template: guestlineTemplate, nameTemplate: 'Guestline_template.xlsx' },
  GuestPro: { template: guestProTemplate, nameTemplate: 'GuestPro_template.xlsx' },
  Hestia: { template: hestiaTemplate, nameTemplate: 'Hestia_template.xlsx' },
  Host: { template: hostTemplate, nameTemplate: 'Host_template.xlsx' },
  Hoteliga: { template: hoteligaTemplate, nameTemplate: 'Hoteliga_template.xlsx' },
  Mews: { template: mewsTemplate, nameTemplate: 'Mews_template.xlsx' },
  Minihotel: { template: minihotelTemplate, nameTemplate: 'Minihotel_template.xlsx' },
  Noray: { template: norayTemplate, nameTemplate: 'Noray_template.xlsx' },
  Noray_htl: { template: norayHTLTemplate, nameTemplate: 'Noray_htl_template.xlsx' },
  Octorate: { template: octorateTemplate, nameTemplate: 'Octorate_template.xlsx' },
  Ohip: { template: ohipTemplate, nameTemplate: 'Ohip_template.xlsx' },
  Ohtels: { template: ohtelsTemplate, nameTemplate: 'Ohtels_template.xlsx' },
  Opera: { template: operaTemplate, nameTemplate: 'Opera_template.xlsx' },
  Othello: { template: othelloTemplate, nameTemplate: 'Othello_template.xlsx' },
  Pasepartout: { template: passepartoutTemplate, nameTemplate: 'Passepartout_template.xlsx' },
  Porthotels: { template: porthotelsTemplate, nameTemplate: 'Porthotels_template.xlsx' },
  Protel: { template: protelTemplate, nameTemplate: 'Protel_template.xlsx' },
  GuestPortal: { template: quohotelTemplate, nameTemplate: 'Quohotel_template.xlsx' },
  Rms: { template: rmsTemplate, nameTemplate: 'Rms_template.xlsx' },
  RoomCloud: { template: roomCloudTemplate, nameTemplate: 'RoomCloud_template.xlsx' },
  SelentaGroup: { template: selentaGroupTemplate, nameTemplate: 'SelentaGroup_template.xlsx' },
  Sihot: { template: sihotTemplate, nameTemplate: 'Sihot_template.xlsx' },
  Sihot360: { template: sihot360template, nameTemplate: 'Sihot360_template.xlsx' },
  Standard2: { template: standard2Template, nameTemplate: 'Standard2_template.xlsx' },
  Standard3: { template: standard3Template, nameTemplate: 'Standard3_template.xlsx' },
  Stelle: { template: stelleTemplate, nameTemplate: 'Stelle_template.xlsx' },
  Suitech: { template: suitechTemplate, nameTemplate: 'Suitech_template.xlsx' },
  Tecsoft: { template: tecsoftTemplate, nameTemplate: 'Tecsoft_template.xlsx' },
  Timon: { template: timonHotelTempalte, nameTemplate: 'TimonHotel_template.xlsx' },
  Tms: { template: tmsTemplate, nameTemplate: 'Tms_template.xlsx' },
  Totvs: { template: totvsTemplate, nameTemplate: 'Totvs_template.xlsx' },
  UlysesCloud: { template: ulysesCloudTemplate, nameTemplate: 'UlysesCloud_template.xlsx' },
  Verial: { template: verialTemplate, nameTemplate: 'Verial_template.xlsx' },
  Winhotel: { template: winhotelTemplate, nameTemplate: 'Winhotel_template.xlsx' },
};

function getSelectedTemplate(pmsSelected) {
  return PMS_TEMPLATES_ID[pmsSelected] || PMS_TEMPLATES_NAME[pmsSelected] || null;
}

function getPmsIdByFilename(filename) {
  for (const [id, data] of Object.entries(PMS_TEMPLATES_ID)) {
    if (data.nameTemplate === filename) {
      return { pms: id, name: data.nameTemplate };
    }
  }
  return null;
}

export { getSelectedTemplate, getPmsIdByFilename };
